import { FC } from "react";
import { IonIcon } from "@ionic/react";
import { football } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { MatchPhone } from "refsix-js-models";
import "./GoalClaimBadges.css";

/** The goals and assists the user claimed in a match (SCORZA-110). */
export const GoalClaimBadges: FC<{ match: MatchPhone }> = ({ match }) => {
    const { t } = useTranslation();
    const goals = match.stats?.myGoalsTotal || 0;
    const assists = match.stats?.myAssistsTotal || 0;
    if (!goals && !assists) return null;

    return (
        <div
            className="goal-claim-badges"
            data-testid={`goalClaimBadges-${match._id}`}
        >
            {goals > 0 && (
                <span
                    className="goal-claim-badge goal-claim-badge--goals"
                    aria-label={t("editMatch.claimRack.badgeGoals", {
                        count: goals,
                    })}
                >
                    <IonIcon icon={football} />
                    {goals}
                </span>
            )}
            {assists > 0 && (
                <span
                    className="goal-claim-badge goal-claim-badge--assists"
                    aria-label={t("editMatch.claimRack.badgeAssists", {
                        count: assists,
                    })}
                >
                    <span className="goal-claim-badge-letter">
                        {t("editMatch.claimRack.assistShort")}
                    </span>
                    {assists}
                </span>
            )}
        </div>
    );
};
